<template>
  <div>
    <v-app-bar app flat class="app-bar white px-2">
      <router-link to="/">
        <v-toolbar-title>
          <v-img src="@/assets/images/header.svg" />
        </v-toolbar-title>
      </router-link>
      <v-spacer></v-spacer>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: 'AppBar',
  components: {},
};
</script>

<style></style>
